<template>
  <view-box
    v-show="$store.state.displaySearchMenu"
    class="view-box"
    :class="{viewboxvisible:isSearchActive}"
    :heading="$t('searchView.heading')"
    icon="mdi-magnify"
  >
    <div
      class="container pt-3"
      :class="{inviewbox:isSearchActive}"
      :style="$mq | mq({
        desktop:'width:100%;position: relative;top:0em;'
      })"
    >
      <div class="controls">
        <mq-layout
          :mq="['mobile', 'tablet']"
        >
          <v-text-field
            v-model="search"
            outlined
            single-line
            :label="$t('searchView.searchText')"
            prepend-inner-icon="mdi-magnify"
            clearable
            @input="lunrRequest();searchResultPage = 1;searchAtPoi = undefined;"
          />
        </mq-layout>
        <mq-layout
          mq="desktop"
        >
          <v-text-field
            v-model="search"
            filled
            clearable
            background-color="rgba(245,245,245,0.95)"
            single-line
            :label="$t('searchView.searchText')"
            prepend-inner-icon="mdi-magnify"
            @input="lunrRequest();searchResultPage = 1;searchAtPoi = undefined;"
            @keyup.esc="$store.commit('closeAllMenus')"
            @keyup.down="searchResultPage++;lunrRequest();"
            @keyup.up="searchResultPage--;lunrRequest();"
          />
        </mq-layout>
        <div
          v-if="searchAtPoi !== undefined"
          class="slide-group searchatpoi-chip-container"
        >
          <v-chip
            :color="baseColor"
            class="searchatpoi-chip"
            @click="search = searchAtPoi.poi.label;lunrRequest();searchResultPage = 1;searchAtPoi = undefined;"
          >
            {{ searchAtPoi.poi.label }}
          </v-chip>
          <v-icon>mdi-chevron-double-right</v-icon>
          <v-chip
            :color="baseColor"
            class="searchatpoi-chip"
          >
            {{ searchAtPoi.cat }}
          </v-chip>
        </div>
        <v-slide-group
          v-else
          v-model="activeCategories"
          class="slide-group"
          prev-icon="mdi-arrow-left-bold"
          next-icon="mdi-arrow-right-bold"
          show-arrows
          multiple
        >
          <v-layout justify-center>
            <v-slide-item
              v-for="(fsIcon,i) in fastSearchIcons"
              :key="i"
              v-slot:default="{ active, toggle }"
              :value="fsIcon.id"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    class="mx-2"
                    :color="active ? `${searchColorOn}` : `${searchColorOff}`"
                    :input-value="active"
                    depressed
                    style="borderRadius:14px;"
                    @click="toggle(); lunrRequest();toggleCategoryLayer(fsIcon, active);searchResultPage = 1;"
                    v-on="on"
                  >
                    <v-badge
                      v-model="showBadge"
                      color="success"
                      overlap
                      class="align-self-center"
                    >
                      <template
                        v-slot:badge
                      >
                        <span>
                          {{ facetCounts[fsIcon.id] }}
                        </span>
                      </template>
                      <v-img
                        v-if="fsIcon.symbol !== undefined"
                        :src="fsIcon.symbol"
                        contain
                        aspect-ratio="1"
                      />
                      <v-icon
                        v-else-if="fsIcon.mdiIcon !== undefined"
                        size="2.5em"
                      >
                        {{ fsIcon.mdiIcon }}
                      </v-icon>
                    </v-badge>
                  </v-btn>
                </template>
                <span class="text-capitalize">{{ fsIcon.id }}</span>
              </v-tooltip>
            </v-slide-item>
          </v-layout>
        </v-slide-group>
      </div>
      <v-expansion-panels
        id="searchResultContainer"
        class="searchResultContainer"
      >
        <search-result
          v-for="result in searchResults"
          :key="result.id"
          :poi="result"
          :searchAtPoi="searchAtPoi"
          style="width:100%;"
        />
      </v-expansion-panels>
      <v-footer
        v-if="numFound > 9 && showPagination"
        width="inherit"
        fixed
        padless
        class="py-2 text-center"
        style="background-color:#fff;"
        :style="$mq | mq({
          tablet:'padding-left:0.5%;width:37%;',
          desktop:'width:26%;'
        })"
      >
        <v-pagination
          v-model="searchResultPage"
          :length="paginationLength"
          style="margin: 0 auto;"
          @input="lunrRequest();"
        />
      </v-footer>
      <v-snackbar
        v-model="showWarningNoSR"
        class="mt-12"
        :timeout="snacktimeout"
        absolute
        bottom
        multi-line
        color="error"
      >
        {{ $t('searchView.noSearchResults') }}
      </v-snackbar>
      <v-snackbar
        v-model="showWarningNoSRinCat"
        class="mt-12"
        :timeout="snacktimeout"
        absolute
        bottom
        multi-line
        color="warning"
      >
        {{ $t('searchView.noSearchResultsInCategory') }}
      </v-snackbar>
      <v-snackbar
        v-model="showWarningMoreText"
        class="mt-12"
        :timeout="snacktimeout"
        absolute
        bottom
        multi-line
        color="warning"
      >
        {{ $t('searchView.needMoreSearchText') }}
      </v-snackbar>
    </div>
  </view-box>
</template>

<script>

import lodash from 'lodash';
import ViewBox from '../ViewBox.vue';
import SearchResult from './SearchResult.vue';
import { EventBus } from '../../event-bus';
import { Mapable } from '../../mixins/Mapable';

export default {
  name: 'SearchView',
  components: {
    ViewBox,
    SearchResult,
  },
  mixins: [Mapable],
  props: {},
  data() {
    return {
      search: '',
      select: '',
      fastSearchIcons: this.$appConfig.categories,
      baseColor: this.$appConfig.baseColor,
      searchColorOn: this.$appConfig.searchColorOn,
      searchColorOff: this.$appConfig.searchColorOff,
      baseColorDark: this.$appConfig.baseColorDark,
      mapCenter: this.$appConfig.mapCenter,
      searchResults: [],
      facetCounts: [],
      activeCategories: [],
      showWarningNoSR: false,
      showWarningNoSRinCat: false,
      showWarningMoreText: false,
      snacktimeout: 1000,
      showBadge: false,
      searchGeom: undefined,
      searchResultPage: 1,
      numFound: 0,
      searchAtPoi: undefined,
    };
  },
  computed: {
    paginationLength() {
      const length = (Math.round((this.numFound + 5) / 10));
      if (length > 16) {
        return 16;
      }
      return length;
    },
    isSearchActive() {
      if (this.$mq === 'desktop' && this.activeCategories.length === 0 && (this.search === '' || this.search === null)) {
        return false;
      }
      return true;
    },
    currentSearchText() {
      return this.search;
    },
    currentSearchCats() {
      return this.categories;
    },
    showPagination() {
      if (this.activeCategories.length === 0 && (this.search === '' || this.search === null)) {
        return false;
      }
      return true;
    },
  },
  watch: {
    searchResultPage(nv) {
      if (nv > this.paginationLength) {
        this.searchResultPage = this.paginationLength;
      }
      if (nv < 1) {
        this.searchResultPage = 1;
      }
      if (nv > 16) {
        this.searchResultPage = 16;
      }
    },
  },
  created() {
    this.lunrRequest = lodash.debounce(async () => {
      const vm = this;
      const lonlat = vm.map.getCenter();
      let distance;
      if (this.searchGeom !== undefined) {
        const centerCoordinate = this.searchGeom.centerCoordinate.split(',');
        lonlat.lng = parseFloat(centerCoordinate[1]);
        lonlat.lon = parseFloat(centerCoordinate[0]);
        distance = 0.001;
      }
      if (vm.$mq === 'desktop' && vm.activeCategories.length === 0 && (vm.search === '' || vm.search === null)) {
        vm.showBadge = false;
      }

      if (!vm.search && vm.activeCategories.length === 0) {
        vm.searchResults = [];
      } else {
        const lunrResponse = await vm.$lunr.search(
          vm.search,
          vm.activeCategories,
          vm.searchResultPage,
          lonlat.lat,
          lonlat.lng,
          distance,
        );
        vm.searchResults = lunrResponse.response;
        vm.facetCounts = lunrResponse.facets;
        vm.numFound = lunrResponse.numFound;
        /* for demo purpose solely */
        /* from here */
        vm.fastSearchIcons.forEach((cat) => {
          if (!(cat.id in vm.facetCounts)) {
            vm.facetCounts[cat.id] = 0;
          }
        });
        /* till here */

        if (vm.searchResults.length === 0) {
          if (vm.activeCategories.length !== 0) {
            vm.showWarningNoSRinCat = true;
          } else if (vm.search.length < 5) {
            vm.showWarningMoreText = true;
          } else {
            vm.showWarningNoSR = true;
          }
        }

        if (vm.search !== '' || vm.activeCategories.length !== 0) {
          vm.showBadge = true;
        }
        // reset search geom after request has finished
        this.searchGeom = undefined;
      }
    }, 300);
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'closeAllMenus') {
        this.search = '';
        this.searchAtPoi = undefined;
        this.activeCategories = [];
        this.searchResults = [];
        this.facetCounts = [];
        this.showBadge = false;
      }
    });
  },
  mounted() {
    EventBus.$on('handleSolrRequest', (catToSearchFor, geom) => {
      this.$store.commit('closeDetailView');
      this.activeCategories = [];
      this.searchGeom = geom;
      this.search = catToSearchFor;
      this.searchAtPoi = undefined;
      this.lunrRequest();
      this.searchResultPage = 1;
    });
    EventBus.$on('searchAtPoi', (catToSearchFor, geom) => {
      this.searchAtPoi = {
        poi: geom,
        cat: catToSearchFor,
      };
      EventBus.$emit('markerAt', geom.centerCoordinate.split(',').map(Number).reverse(), '#ff0000', false);
      this.$store.commit('closeDetailView');
      this.activeCategories = [];
      this.searchGeom = geom;
      this.search = catToSearchFor;
      this.lunrRequest();
      this.searchResultPage = 1;
    });
  },
  methods: {
    onMapBound() {
    },
    setSearchText(stxt, d) {
      this.search = `${stxt} ${d}`;
      this.lunrRequest();
    },
    toggleCategoryLayer(cat, onoff) {
      if (cat.toggleLayer) {
        EventBus.$emit('toggleLayer', cat.toggleLayer, onoff);
      }
    },
  },
};

</script>

<style scoped>
  .container {
    background-color: transparent;
    visibility: visible;
    /* width: inherit; */
  }

  .searchResultContainer {
    margin-top: 2vh;
    padding-bottom: 60px;
    overflow-y: auto;
    }
    .remove-scroll-bar {
    -ms-overflow-style: none;  /* IE 10+ */
    scrollbar-width: none;  /* Firefox */
    }
    .remove-scroll-bar::-webkit-scrollbar {
      display: none;
    }
    .pagination {
      position: sticky;
      bottom: 0;
      z-index: 100;
      padding: 20px 0;
      width: 100%;
      background-color: #0ff;
      left: 0;
    }
    .searchatpoi-chip-container {
      display: flex;
      justify-content: space-around;
    }
    .searchatpoi-chip {
      width: calc(45%);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  @media (min-width: 1250px) {
    .viewboxvisible {
      visibility: visible;
    }
    .inviewbox {
      top: auto !important;
    }
  }
</style>
